export default "__VITE_ASSET__C8A3FmnP__"